// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-select-container {
  padding: 0 0.8rem;
}

.common-label-text {
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.2rem;
  margin-top: 1.2rem;
  color: #202020;
}

.common-select-text {
  width: 100%;
  border: 1px solid #e6e6e6;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #202020;
  font-weight: 500;
}
.td--reorder {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/legalAndPolicies/PolicyEditor.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd","sourcesContent":[".common-select-container {\n  padding: 0 0.8rem;\n}\n\n.common-label-text {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-bottom: 0.2rem;\n  margin-top: 1.2rem;\n  color: #202020;\n}\n\n.common-select-text {\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8rem;\n  color: #202020;\n  font-weight: 500;\n}\n.td--reorder {\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
